<template lang="pug">
div.container
  div.body
    div
      img.back-button( src="@/assets/ic-left.svg" @click="recoverPass()")
      div.logo
        img( src="@/assets/kiddiecoinLogo.svg")
      div.header
        span.text-23-b Регистрация
      div.password-text.text-16
        div.mb-2 Регистрация осуществляется только при личном визите в офис.
        div.mb-2 Для регистрации необходимо присутствие родителя (законного представителя) и предоставление оригиналов документов, подтверждающих личность и право представительства.
        div.mb-2 Специалист офиса проверит документы, поможет заполнить данные и завершит регистрацию.
        div.mb-2 Онлайн-регистрация и удалённая подача документов не предусмотрены.
        div.mb-2 Если у вас есть вопросы по перечню документов или порядку регистрации, обратитесь к сотруднику офиса — мы с радостью поможем.
</template>

<script>
export default{
  name:"UserRegistration",

  props: {
    devId: null
  },

  methods: {
    recoverPass() {
      window.location.href = "#logout"
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.body {
  width: auto;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 16px 0px 16px;
}
.logo {
  margin: 0px 0px 10px 0px;
}
.header {
  text-align: center;
  margin: 30px 0;
}
.password-text {
  text-align: start;
}
.back-button {
  display: flex;
}
</style>